import { proceedToOnHoldAction } from "../../../Actions/UIActions/OnHoldBooking/ProceedToOnHoldAction";
import { ExecutionStatus } from "../../../core/enum/ExecutionStatus";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { bookingTree } from "../../../Orchestrator/ConstantTree";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { OnHoldBookingContext } from "../Context/OnHoldBookingContext";

class OnHoldBookingInitStep extends StepFlow {
    get stepName() { return "OnHoldBookingInit_Step"; }

    async onEventSetup(): Promise<void> {
        /**
        * This event used to close flow
        */
        _eventBus.on<void, void>({
            eventName: bookingTree.OnHold.Flow.Close,
            handler: async (payload) => {
                // Ensure on hold booking state is fully reset on close
                const context = this.getCtx<OnHoldBookingContext>("onHoldBookingContext")!
                if (context) {
                    context.routeTo = []
                    this.next()
                }
            }
        })

        this.registerEventSubscription(
            _eventBus.on({
                eventName: bookingTree.OnHold.Pay.Click,
                handler: async (data: any) => {
                    proceedToOnHoldAction.setParams(data.data!);
                    await proceedToOnHoldAction.execute();
                    if (proceedToOnHoldAction.status.executionStatus === ExecutionStatus.SUCCESS) {
                        const data: IDefaultActionResult = proceedToOnHoldAction.result!;
                        if (data.status === "success") {
                            try {
                                sessionStorage.setItem("checkoutFromWithLogin", "true");
                            } catch (error) {
                                console.error("Error setting sessionStorage checkoutFromWithLogin:", error);
                            }

                            const onHoldBookingContext = this.getCtx<OnHoldBookingContext>("onHoldBookingContext");
                            if (onHoldBookingContext) {
                                onHoldBookingContext.routeTo = ["CheckoutFlow"];
                                this.next();
                            }


                            // Delay the ROUTE_CHANGE event emission slightly
                            setTimeout(() => {
                                _eventBus.emit({
                                    eventName: "ROUTE_CHANGE",
                                    data: "/checkout"
                                });
                            }, 0);
                        }
                    }
                }
            })
        )
    }

    async onExecute(): Promise<void> {
        console.log("OnHoldBooking Init Step Execute.............................")
    }
}

export const OnHoldBookingInitStepDeclaration = new StepDefinition({
    stepName: "OnHoldBookingInit_Step",
    stepClass: OnHoldBookingInitStep
});